import React from "react";
import PropTypes from "prop-types";
import {styled} from "@mui/material/styles";
import LoadingButton from "@mui/lab/LoadingButton";

import {Title} from "@/components/typography/index.jsx";

export default function RestoreFromLocalStorageDialog({restoreFromStorage = () => {}, resetStorage = () => {}}) {
    return (
        <Container>
            <Text>You have previously filled in this form, would you like us to restore the data?</Text>

            <ButtonsContainer>
                <LoadingButton
                    variant="cancel"
                    type="buttom"
                    size="medium"
                    onClick={resetStorage}
                >
                    No Thanks
                </LoadingButton>

                <LoadingButton
                    variant="contained"
                    type="buttom"
                    size="medium"
                    onClick={restoreFromStorage}>
                    Restore
                </LoadingButton>
            </ButtonsContainer>
        </Container>
    );
}

RestoreFromLocalStorageDialog.propTypes = {
    children: PropTypes.string,
};

const Container = styled('div')({
    borderRadius: '25px',
    minWidth: '380px',

    '@media (max-width: 500px)': {
        minWidth: 'auto',
        minHeight: 'auto',
    },
});

const Text = styled(Title)({
    textAlign: 'center',
});

const ButtonsContainer = styled('div')({
    paddingTop: '10px',
    paddingBottom: '10px',
    marginTop: '20px',
    display: 'flex',
    gap: '10px',

    '& > button': {
        minWidth: 'auto',
        display: 'flex',
        flex: 1,
    },
});
